import { AxiosError } from "axios";
import * as R from "../../../requests/x2y/requestCreators";
import { BulkX2yResponse } from "../../../requests/x2y/types";
import flowioast from "../../../utils/flowioast";
import { FlowioThunkCreator } from "../../types";
import * as AC from "../actionCreators";
import * as S from "../selectors";
import { X2yController } from "../types";

type MakeThunkCreatorParams = {
  controller: X2yController;
};

// Thunk creator types
type ThunkCreatorParams = { xIds: number[]; payload: BulkX2yResponse };

export type BulkUpdateThunkCreator = FlowioThunkCreator<ThunkCreatorParams>;
export type MakeBulkUpdateThunkCreator = (
  p: MakeThunkCreatorParams
) => BulkUpdateThunkCreator;

// ==== FACTORY ====
const createBulkUpdateThunk: MakeBulkUpdateThunkCreator = ({ controller }) => {
  const getIsSubmitting = S.creteGetIsSubmitting(controller);
  const request = R[controller].updateBulk;

  return ({ xIds, payload }) =>
    (dispatch, getState) =>
      Promise.resolve().then(async () => {
        const areSomeIdsAlreadySubmitting = getIsSubmitting(getState(), xIds);
        if (areSomeIdsAlreadySubmitting) return;

        const reqPayload = { controller, xIds, payload };
        dispatch(AC.bulkUpdateX2yRequest(reqPayload));

        try {
          const response = await request(xIds, payload);

          const recPayload = { controller, xIds, x2ys: response.data };
          dispatch(AC.bulkUpdateX2yReceive(recPayload));

          flowioast.success.fromIntlBase("settings.save.singular");
        } catch (error) {
          const errPayload = {
            controller,
            xIds,
            error: (error as AxiosError).response || error,
          };
          dispatch(AC.bulkUpdateX2yError(errPayload));
          flowioast.error.fromIntlBase("settings.save.singular", error);
        }
      });
};

export default createBulkUpdateThunk;
